export default __webpack_public_path__ + "static/media/bg01.09c8169e.jpg";